import { render, staticRenderFns } from "./OrderSummaryFooter.vue?vue&type=template&id=c7dd31b6&scoped=true&"
import script from "./OrderSummaryFooter.vue?vue&type=script&lang=ts&"
export * from "./OrderSummaryFooter.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSummaryFooter.vue?vue&type=style&index=0&id=c7dd31b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dd31b6",
  null
  
)

export default component.exports